module.exports = __webpack_public_path__ + "img/img-8-desk.c17ab12f.jpg";